import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import { NavLink, Outlet, useLocation } from "react-router";
import React, { useMemo } from "react";
import useApp from "./useApp";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import { NetworkErrorModal } from "./common/AppModal";
import clsx from "clsx";
import moment from "moment";

export const AppContext = React.createContext({});

function App() {
  const {
    toggleLeftMenu,
    closeLeftMenuMobile,
    logout,
    initialized
  } = useApp();

  const menuState = useSelector(state => state.app.menuState);
  const token = useSelector(state => state.app.token);

  const { pathname } = useLocation();

  const isPlanningActive = pathname === "/" || pathname.startsWith("/planning");

  const providerValue = useMemo(() => ({}), []);

  if (!initialized) {
    return null;
  }

  return (
    <AppContext.Provider value={providerValue}>
      <div id="app" className={menuState ? "menu-state-1" : "menu-state-2"}>
        <div id="top-border">
          <div id="content-rounded-border">
            <div/>
          </div>
        </div>

        <div id="left-menu" className={clsx("custom-scrollbar")}>
          <Logo/>

          <NavLink to={"/planning/" + moment().format("YYYY/MM/DD")}
                   className={({ isActive }) =>
                     (isActive || isPlanningActive) ? "menu-entry nav-link active" : "menu-entry nav-link"
                   }
                   onClick={closeLeftMenuMobile}>
            <span className="menu-icon"><span className="material-icons">event</span></span>
            <span className="menu-name">Planning</span>
          </NavLink>

          <NavLink to="/sites?active=1" className="menu-entry" onClick={closeLeftMenuMobile}>
            <span className="menu-icon"><span className="material-icons">construction</span></span>
            <span className="menu-name">Chantiers</span>
          </NavLink>

          <NavLink to="/memos" className="menu-entry" onClick={closeLeftMenuMobile}>
            <span className="menu-icon"><span className="material-icons">content_paste</span></span>
            <span className="menu-name">Mémos techniques</span>
          </NavLink>

          <NavLink to="/vehicules" className="menu-entry" onClick={closeLeftMenuMobile}>
            <span className="menu-icon"><span className="material-icons">directions_car</span></span>
            <span className="menu-name">Véhicules</span>
          </NavLink>

          <NavLink to="/purchases" className="menu-entry" onClick={closeLeftMenuMobile}>
            <span className="menu-icon"><span className="material-icons">add_shopping_cart</span></span>
            <span className="menu-name">Matériel à acheter</span>
          </NavLink>

          <NavLink to="/contacts" className="menu-entry" onClick={closeLeftMenuMobile}>
            <span className="menu-icon"><span className="material-icons">group</span></span>
            <span className="menu-name">Contacts</span>
          </NavLink>

          <div id="menu-separator"/>

          <div className="menu-divider"/>

          <NavLink to="/parameters" className="menu-entry" onClick={closeLeftMenuMobile}>
            <span className="menu-icon"><span className="material-icons">settings</span></span>
            <span className="menu-name">Paramètres</span>
          </NavLink>

          <div className="menu-entry logout" onClick={logout}>
            <span className="menu-icon"><span className="material-icons">logout</span></span>
            <span className="menu-name">
              Déconnexion
              <br/>
              <span className="email">{token.email}</span>
            </span>
          </div>
        </div>

        <div id="content">
          <Outlet/>

          <NetworkErrorModal/>

          <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={true}
            pauseOnFocusLoss={false}
            closeOnClick
            rtl={false}
            theme="dark"
          />
        </div>

        <div id="left-menu-overlay" className={menuState ? "state-1" : "state-2"} onClick={toggleLeftMenu}/>
      </div>
    </AppContext.Provider>
  );
}

const Logo = () => {
  return <div id="app-logo">
    <img src="/android-chrome-192x192.png" alt="Logo"/>

    <div id="app-name">Willaime</div>
  </div>;
};

export default App;
